import type { Item } from '../../schemas/item.ts';
import type { ItemStats } from '../../schemas/item-stats.ts';

// Re-export parseEnrichedData from shared utility module
export { parseEnrichedData } from '../../utils/enriched-data';

// === Shared types & utilities for item card internals ===

/** ItemResource is a reactive item or item-stats record */
export type ItemResource = Item | ItemStats;

export interface ItemDetailsSignature {
  Args: {
    data: Record<string, unknown> | null;
    item: ItemResource;
    /** Optional formatted distance string (e.g., "2.3 km") */
    distance?: string | null;
  };
}
